/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_LoadingInputs */

const en_dr_pick_loading = /** @type {(inputs: Dr_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening your Design Rooms…`)
};

const id_dr_pick_loading = /** @type {(inputs: Dr_Pick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuka Design Room kamu…`)
};

/**
* | output |
* | --- |
* | "Opening your Design Rooms…" |
*
* @param {Dr_Pick_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_loading = /** @type {((inputs?: Dr_Pick_LoadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_LoadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_loading(inputs)
	return en_dr_pick_loading(inputs)
});